// extracted by mini-css-extract-plugin
module.exports = {"articles":"SectionReadOften_articles__7lIgu","article":"SectionReadOften_article__BZa2D"};